import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { EChartsOption } from 'echarts';
import { cloneDeep, defaultsDeep } from 'lodash-es';

import * as fromChartSelectors from '../../../store/selectors/chart.selectors';
import { GenericComponent } from '../generic/generic.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-chart',
  standalone: false,
  templateUrl: './chart.component.html'
})
export class ChartComponent extends GenericComponent implements OnChanges, OnInit {
  private store = inject(Store);

  defaultChartOptions: EChartsOption = {
    textStyle: {
      color: '#333',
      fontFamily: 'San Francisco Display',
      fontSize: 12
    }
  };

  @Input() options?: EChartsOption;

  colors: string[] = [];

  chartOptions: EChartsOption = cloneDeep(this.defaultChartOptions);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.chartOptions = defaultsDeep(changes['options'], this.defaultChartOptions);
    }
  }

  ngOnInit() {
    this.chartOptions = defaultsDeep(this.options, this.defaultChartOptions);
    this.addUniqueSubscription(
      'colorsSubscription',
      this.store.pipe(select(fromChartSelectors.selectColors)).subscribe((colors) => {
        this.defaultChartOptions.color = colors;
        this.chartOptions = defaultsDeep(this.options, this.defaultChartOptions);
      })
    );
  }
}
